import React from "react";
import { baseUrl } from "../../helpers/url_api_constant";
import { getPermission, getUserToken } from "../../helpers/auth_helper";
import moment from "moment";
import { useDispatch } from "react-redux";
import OverButton from "../../components/Custom/Overbutton";
import * as loadingAction from "../../store/loading/action";

const DownloadManual = () => {
  const dispatch = useDispatch();
  const date = moment(new Date()).format("DD.MM.YYYY");

  const downloadWord = async (data) => {
    // console.log(row);
    dispatch(loadingAction.showLoading());
    const accessToken = JSON.parse(localStorage.getItem("accessToken"));
    fetch(baseUrl + "api/DownloadFile/DownloadFile?downloadData=" + data, {
      method: "GET",
      headers: {
        "Content-Type": "application/msword", //msword
        Authorization: "Bearer " + accessToken.access_token,
        TSOSESSIONID: getUserToken(),
      },
    })
      .then(
        response => response.blob()
          // console.log(response); ถ้าจะ log ให้ใส่ {}
      )
      .then(blob => {
        // Create blob link to download
        // console.log(blob);
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          // `FileName.xlsx`,
          "TSO " + data + " " + date + ".docx"
        );
        // Append to html link element page
        document.body.appendChild(link);
        // Start download
        link.click();
        // Clean up and remove the link
        link.parentNode.removeChild(link);
        dispatch(loadingAction.hideLoading());
      });
  };

  const downloadPowerPoint = async (data) => {
    // console.log(row);
    dispatch(loadingAction.showLoading());
    const accessToken = JSON.parse(localStorage.getItem("accessToken"));
    fetch(baseUrl + "api/DownloadFile/DownloadFile?downloadData=" + data, {
      method: "GET",
      headers: {
        "Content-Type": "application/vnd.ms-powerpoint",
        Authorization: "Bearer " + accessToken.access_token,
        TSOSESSIONID: getUserToken(),
      },
    })
      .then(
        response => response.blob()
        // console.log(response); ถ้าจะ log ให้ใส่ {}
      )
      .then(blob => {
        // Create blob link to download
        // console.log(blob);
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          // `FileName.xlsx`,
          data + '_ENH-TSO Operation Report ' + date + '.pptx'
        );
        // Append to html link element page
        document.body.appendChild(link);
        // Start download
        link.click();
        // Clean up and remove the link
        link.parentNode.removeChild(link);
        dispatch(loadingAction.hideLoading());
      });
  };

  return (
    <div className="d-flex align-items-center justify-content-center">
      <OverButton
        onClick={() => {
          downloadWord("AdminManual");
        }}
        color="link"
        icon="bx bx-book-content bx-sm"
        label="Admin Manual"
      ></OverButton>

      <OverButton
        onClick={() => {
          downloadWord("UserManual");
        }}
        color="link"
        icon="bx bx-detail bx-sm"
        label="User Manual"
      ></OverButton>

      <OverButton
        onClick={() => {
          downloadPowerPoint("AdminTraining");
        }}
        color="link"
        icon="bx bxs-book-open bx-sm"
        label="Admin Training"
      ></OverButton>

      <OverButton
        onClick={() => {
          downloadPowerPoint("UserTraining");
        }}
        color="link"
        icon="bx bx-file bx-sm"
        label="User Training"
      ></OverButton>
    </div>
  );
};

export default DownloadManual;
